'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isEmail = function (email) {
    var value = (email || '').toLowerCase();
    var emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailPattern.test(value);
};

exports.default = isEmail;
//# sourceMappingURL=index.js.map
